import { CreatorType } from "@/types/practice-test"

export const hoverActiveEffect =
  'transition-all duration-200 ease-out ' +
  'hover:-translate-y-0.5 hover:shadow-md ' +
  'active:translate-y-0 active:scale-[0.98] active:shadow-sm cursor-pointer'

export const hoverPressEffect =
  'transition-all duration-200 ease-out ' +
  'hover:-translate-y-0.5 hover:shadow-md ' +
  'active:translate-y-0 active:scale-[0.98] active:shadow-sm cursor-pointer'

export const hoverPressable =
  'transition-all duration-200 ease-out ' +
  'hover:-translate-y-0.5 hover:shadow-md shadow-white/20 ' +
  'px-[16px] rounded-2xl ' +
  'active:translate-y-0 active:scale-[0.98] active:shadow-sm cursor-pointer'

export const ragRange = {
  g: 52,
  a: 45,
}

export const getMarksStyle = (
  mark?: number | string,
  totalMarks?: number,
  background?: boolean
) => {
  if (background) {
    if (mark === undefined || mark === null || mark === 'N/A') return 'bg-white'
    if (totalMarks != null && totalMarks !== 0) {
      const percentage = (Number(mark) / Number(totalMarks)) * 100
      switch (true) {
        case percentage === 0:
          return '!bg-[#FEF3F2]'
        case percentage < ragRange.a:
          return '!bg-[#FEF3F2]'
        case percentage >= ragRange.a && percentage <= ragRange.g:
          return '!bg-[#FFFAEB]'
        case percentage > ragRange.g:
          return '!bg-[#ECFDF3]'
        default:
          return 'bg-white'
      }
    }
    switch (true) {
      case Number(mark) === 0:
        return '!bg-[#FEF3F2]'
      case Number(mark) < ragRange.a:
        return '!bg-[#FEF3F2]'
      case Number(mark) >= ragRange.a && Number(mark) <= ragRange.g:
        return '!bg-[#FFFAEB]'
      case Number(mark) > ragRange.g:
        return '!bg-[#ECFDF3]'
      default:
        return 'bg-white'
    }
  }
  if (mark === undefined || mark === null || mark === 'N/A')
    return 'text-[#002652]'
  if (totalMarks != null && totalMarks !== 0) {
    const percentage = (Number(mark) / Number(totalMarks)) * 100
    switch (true) {
      case percentage === 0:
        return '!text-[#D92D20]'
      case percentage < ragRange.a:
        return '!text-[#D92D20]'
      case percentage >= ragRange.a && percentage <= ragRange.g:
        return '!text-[#F79009]'
      case percentage > ragRange.g:
        return '!text-[#079455]'
      default:
        return 'text-[#002652]'
    }
  }
  switch (true) {
    case Number(mark) === 0:
      return '!text-[#D92D20]'
    case Number(mark) < ragRange.a:
      return '!text-[#D92D20]'
    case Number(mark) >= ragRange.a && Number(mark) <= ragRange.g:
      return '!text-[#F79009]'
    case Number(mark) > ragRange.g:
      return '!text-[#079455]'
    default:
      return 'text-[#002652]'
  }
}

export const getMarksPercentageStyle = (
  userMark?: number,
  totalMarks?: number
) => {
  if (userMark === undefined || totalMarks === undefined) return 'bg-white'

  const percentage = (userMark / totalMarks) * 100

  switch (true) {
    case percentage === 0:
      return '!bg-[#e65555]'
    case percentage < ragRange.a:
      return '!bg-[#e65555]'
    case percentage >= ragRange.a && percentage <= ragRange.g:
      return '!bg-[#ebc860]'
    case percentage > ragRange.g:
      return '!bg-[#17B26A]'
    default:
      return 'bg-white'
  }
}

export const getMarksPercentage = (mark?: number | string | null) => {
  if (mark === undefined || mark === null) return 'N/A'
  return `${mark}%`
}

export function getCreatorLabel(value: CreatorType | string | null): string {
  if (!value) return 'Admin Created'
  if (value === CreatorType.COMMON) return 'Admin Created'
  if (value === CreatorType.TUTOR_CREATED || value === 'TUTOR')
    return 'Tutor Created'
  if (value === CreatorType.STUDENT_CREATED || value === 'STUDENT')
    return 'Student Created'
  return 'Admin Created'
}
